import 'jquery-mousewheel';

export default class Zoom {
    constructor(container, config) {
        let defaultConfig = {
            zoomBlock: container.children().eq(0),
            minZoom: 1,
            maxZoom: 5
        };

        config = Object.assign(defaultConfig, config);

        this.config = config;
        this.container = container;
        this.zoomBlock = config.zoomBlock;
        this._dragging = false;
        this._zooming = false;
        this._currentZoom = 1;
        this._initialWidth = container[0].offsetWidth;
        this._currentTranslate = {
            x: 0,
            y: 0
        };

        this._bindEvents();
    }

    zoom(factor, animate = true, origin = null) {
        let newZoom = this._currentZoom * factor;

        if (factor < 1 && this._currentZoom === this.config.minZoom || (factor > 1 && this._currentZoom === this.config.maxZoom)) {
            return;
        }
        if (newZoom < this.config.minZoom) {
            newZoom = this.config.minZoom;
        } else if (newZoom > this.config.maxZoom) {
            newZoom = this.config.maxZoom;
        }

        let holder = this.zoomBlock;
        let viewPort = this.container;
        let newWidth = this._initialWidth * newZoom;
        let currentTranslate = this._currentTranslate;

        origin = origin || {
            x: viewPort[0].offsetWidth / 2,
            y: viewPort[0].offsetHeight / 2
        };

        let currentPoint = {
            x: origin.x - currentTranslate.x,
            y: origin.y - currentTranslate.y
        };
        let newPoint = {
            x: currentPoint.x / this._currentZoom * newZoom,
            y: currentPoint.y / this._currentZoom * newZoom
        };
        let translateX = newPoint.x - currentPoint.x;
        let translateY = newPoint.y - currentPoint.y;

        if (animate) {
            let lastStepTranslate = {
                x: currentTranslate.x,
                y: currentTranslate.y
            };
            holder.animate({width: newWidth}, {
                duration: 200,
                easing: 'linear',
                progress: (tween, progress) => {
                    let newTranslate = {
                        x: currentTranslate.x + translateX * progress,
                        y: currentTranslate.y + translateY * progress
                    };
                    this._translate(lastStepTranslate.x - newTranslate.x, lastStepTranslate.y - newTranslate.y);

                    lastStepTranslate = newTranslate;
                }
            });
        } else {
            holder.css('width', newWidth);
            this._translate(-translateX, -translateY);
        }

        this._currentZoom = newZoom;
    }

    update() {
        this._initialWidth = this.container[0].offsetWidth;
        this.zoom(1, false);
    }

    destroy() {
        this.zoomBlock.off('mousedown', this.mouseDownHandler);
        this.zoomBlock.off('touchstart', this.touchStartHandler);
        this.zoomBlock.off('mousewheel', this.wheelHandler);
        $(window).off('resize', this.resizeHandler);
    }

    _bindEvents() {
        let _this = this;

        this.mouseDownHandler = e => {
            let lastPosition = {
                x: e.pageX,
                y: e.pageY
            };

            $(window).on('mousemove', moveHandler);
            $(window).on('mouseup', stopMove);

            function moveHandler(e) {
                _this._translate(e.pageX - lastPosition.x, e.pageY - lastPosition.y);

                lastPosition.x = e.pageX;
                lastPosition.y = e.pageY;
            }

            function stopMove() {
                $(window).off('mousemove', moveHandler);
                $(window).off('mouseup', stopMove);
            }
        };

        this.touchStartHandler = e => {
            if (e.touches.length === 1) {
                this._startDrag(e);
            } else if (e.touches.length === 2) {
                this._startZoom(e);
            }
        };

        this.wheelHandler = e => {
            e.preventDefault();
            this._translate(-e.deltaX * e.deltaFactor, e.deltaY * e.deltaFactor);
        };

        this.resizeHandler = () => {
            this.update();
        };

        this.zoomBlock.on('mousedown', this.mouseDownHandler);
        this.zoomBlock.on('touchstart', this.touchStartHandler);
        this.zoomBlock.on('mousewheel', this.wheelHandler);
        $(window).on('resize', this.resizeHandler);
    }

    _startDrag(e) {
        if (this._dragging) {
            return;
        }
        this._dragging = true;
        e.preventDefault();

        let _this = this;

        window.addEventListener('touchmove', moveHandler, {passive: false});
        $(window).on('touchend', stopDrag);

        let lastPosition = {
            x: e.touches[0].clientX,
            y: e.touches[0].clientY
        };

        function moveHandler(e) {
            if (e.touches.length === 2) {
                stopDrag();
                _this._startZoom(e);

                return;
            }
            e.preventDefault();

            let position = {
                x: e.touches[0].clientX,
                y: e.touches[0].clientY
            };

            _this._translate(position.x - lastPosition.x, position.y - lastPosition.y);

            lastPosition = position;
        }

        function stopDrag() {
            window.removeEventListener('touchmove', moveHandler);
            $(window).off('touchend', stopDrag);
            _this._dragging = false;
        }
    }

    _startZoom(e) {
        if (this._zooming) {
            return;
        }
        this._zooming = true;
        e.preventDefault();

        let _this = this;

        window.addEventListener('touchmove', moveHandler, {passive: false});
        $(window).on('touchend', stopZoom);

        let lastDistance = null;
        let viewPortRect = this.container[0].getBoundingClientRect();
        let lastPosition = getTouchesCenter(e.touches);

        function moveHandler(e) {
            e.preventDefault();

            let center = getTouchesCenter(e.touches);
            let distance = Math.sqrt(
                Math.pow(e.touches[0].clientX - e.touches[1].clientX, 2) +
                Math.pow(e.touches[0].clientY - e.touches[1].clientY, 2)
            );
            let distanceDiff;

            if (lastDistance === null) {
                distanceDiff = 0;
            } else {
                distanceDiff = distance - lastDistance;
            }

            _this.zoom(distanceDiff / 200 + 1, false, center);
            _this._translate(center.x - lastPosition.x, center.y - lastPosition.y);

            lastDistance = distance;
            lastPosition = center;
        }

        function stopZoom(e) {
            window.removeEventListener('touchmove', moveHandler);
            $(window).off('touchend', stopZoom);
            _this._zooming = false;

            if (e.touches.length === 1) {
                _this._startDrag(e);
            }
        }

        function getTouchesCenter(touches) {
            return {
                x: (touches[0].clientX + touches[1].clientX) / 2 - viewPortRect.left,
                y: (touches[0].clientY + touches[1].clientY) / 2 - viewPortRect.top
            };
        }
    }

    _translate(dx, dy) {
        let holder = this.zoomBlock;
        let viewPort = this.container;
        let maxX = viewPort[0].offsetWidth - holder[0].offsetWidth;
        let maxY = viewPort[0].offsetHeight - holder[0].offsetHeight;
        let translate = {
            x: this._currentTranslate.x + dx,
            y: this._currentTranslate.y + dy
        };

        if (translate.x < maxX) {
            translate.x = maxX;
        }
        if (translate.y < maxY) {
            translate.y = maxY;
        }
        if (translate.x > 0) {
            translate.x = 0;
        }
        if (translate.y > 0) {
            translate.y = 0;
        }

        holder.css('transform', `translate3d(${translate.x}px, ${translate.y}px, 0)`);

        this._currentTranslate = translate;
    }
}



// WEBPACK FOOTER //
// resources/assets/src/js/Zoom.js